export default {
  thread: state => state.thread,
}
